import { defineStore } from "pinia";
import { ref } from "vue";

export const useToast = defineStore("toast", () => {
  const message = ref("");
  const visible = ref(false);
  let timer: ReturnType<typeof setTimeout> | undefined;

  function show(msg: string) {
    message.value = msg;
    visible.value = true;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => { visible.value = false; }, 2600);
  }
  return { message, visible, show };
});
